import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { ownershipRightsNonTrfFinanceConfig } from './OwnershipRightsNonTrfFinance.name';

/** 所有権移転外ファイナンスのENUM */
enum OwnershipRightsNonTrfFinance {
  /** オンバランス   */
  onBalance = '1',
  /** オフバランス */
  offBalance = '2',
}

const ownershipRightsNonTrfFinanceMap = new Map([
  ['1', OwnershipRightsNonTrfFinance.onBalance],
  ['2', OwnershipRightsNonTrfFinance.offBalance],
]);

const rawValueToOwnershipRightsNonTrfFinance = rawValueToEnumWithDefault(
  ownershipRightsNonTrfFinanceMap,
  OwnershipRightsNonTrfFinance.onBalance,
);

const ownershipRightsNonTrfFinanceToDisplay = enumToNameWithDefault(
  OwnershipRightsNonTrfFinance,
  ownershipRightsNonTrfFinanceConfig,
);

const ownershipRightsNonTrfFinanceToDisplayWithPrefix = enumToNameWithDefault(
  OwnershipRightsNonTrfFinance,
  ownershipRightsNonTrfFinanceConfig,
  true,
);

export {
  OwnershipRightsNonTrfFinance,
  ownershipRightsNonTrfFinanceToDisplay,
  ownershipRightsNonTrfFinanceToDisplayWithPrefix,
  rawValueToOwnershipRightsNonTrfFinance,
};
